import { __assign, __extends, __rest } from "tslib";
import { Shape } from '../types';
import { DisplayObject } from './DisplayObject';

var Polygon =
/** @class */
function (_super) {
  __extends(Polygon, _super);

  function Polygon(_a) {
    if (_a === void 0) {
      _a = {};
    }

    var style = _a.style,
        rest = __rest(_a, ["style"]);

    return _super.call(this, __assign({
      type: Shape.POLYGON,
      style: __assign({
        points: [],
        miterLimit: 4,
        lineWidth: 1
      }, style)
    }, rest)) || this;
  }

  return Polygon;
}(DisplayObject);

export { Polygon };